import * as THREE from "three";
import Experience from "./Experience.js";

export default class Loading {
  constructor() {
    this.experience = new Experience();
    this.resources = this.experience.resources;

    this.loader = document.getElementById("loader");
    this.progressBar = document.getElementById("progressBar");
    this.progress = document.getElementById("progress");
    this.progressValue = document.getElementById("progressValue");

    this.processedResources = 0;
    this.totalResources = 0;
  }

  setLoadComplete() {
    this.loader.style.display = "none";
  }

  setResourceLength(length) {
    this.totalResources = length;
  }

  incrementProgress() {
    this.processedResources = this.processedResources + 1;
    this.progressBar.style.width =
      (this.processedResources / this.totalResources) * 100 + "%";
    this.progressValue.innerText = `${Math.round(
      (this.processedResources / this.totalResources) * 100,
      2
    )} %`;
  }
}
